import domReady from '../utils/domReady'

const search = () => {
  domReady(() => {
    const searchEl = document.getElementById('searchBar');
    const resultsEl = document.querySelector('.searchwp-live-search-results');
  })
}
search();
